const principles = [
  {
    title: 'Security first',
    desc: 'No secrets in clients. Least privilege by default. Every execution has guardrails and failure paths.',
  },
  {
    title: 'Verifiable delivery',
    desc: 'Every phase ships runnable features, auditable evidence, and repeatable tests.',
  },
  {
    title: 'Explainability and transparency',
    desc: 'Fee breakdowns, route choices, and supplementation logic are understandable and reproducible.',
  },
  {
    title: 'Composable by design',
    desc: 'Replaceable modules: adapters, quoting, negotiation, execution, monitoring.',
  },
]

export default function Principles() {
  return (
    <section id="principles" className="bg-bg">
      <div className="container-x py-14 md:py-18">
        <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">Principles</h2>
        <p className="mt-2 max-w-3xl text-white/65">
          We optimize for systems that stay correct over time—not one-off demos.
        </p>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {principles.map((p, idx) => (
            <div key={p.title} className={idx % 2 === 0 ? 'glass p-7' : 'glass2 p-7'}>
              <div className="flex items-center gap-2 text-sm font-semibold text-white/90">
                <span className={idx % 2 === 0 ? 'h-2 w-2 rounded-full bg-primary' : 'h-2 w-2 rounded-full bg-secondary'} />
                {p.title}
              </div>
              <div className="mt-3 text-sm leading-relaxed text-white/60">{p.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
